import WebshopHeader from './WebshopHeader'

export default WebshopHeader
